import DetailBox from "../../app/Components/DetailBox/DetailBox";
import App from "../../app/App";
import Layout from "../../views/Layout/Layout";
import Clipboard from "../../app/Components/Clipboard/Clipboard";
import Medialist from "./Medialist/Medialist";

const Users = {

    init() {

        this.el = $('[page="Users"]');

        if (!this.el.length) {
            return;
        }

        this.userDetail = this.el.find("button.userDetail");

        this.start();
        this.bind();
    },

    start() {
        Medialist.init();
    },

    bind() {
        this.userDetail.on("click", function (element) {
            clearTimeout(App.ajaxSendProtection);

            App.ajaxSendProtection = setTimeout(() => {
                DetailBox.show();

                setTimeout(() => {
                    let button = $(element.currentTarget).data();

                    let data = {
                        data: button.data
                    };

                    if (button.post) {
                        data.parameters = button.post;
                    }

                    App.showLoading();
                    App.ajax(
                        button.library,
                        button.event,
                        data,
                        (response) => {
                            DetailBox.hideLoading();
                            DetailBox.setScrollContent();
                            Clipboard.create();
                        }
                    )

                    Layout.hideModal(this.dialog);

                },500);

            }, 250);
        });
    }
}
export default Users;